module.exports = __webpack_public_path__ + "static/banner-home-6e077df3eee757de589a896a4ecb7ff2.jpg";